import { render, staticRenderFns } from "./EditarInformacion.vue?vue&type=template&id=fc6e36d6&"
import script from "./EditarInformacion.vue?vue&type=script&lang=js&"
export * from "./EditarInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports